//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "RFAHAJONES",
  data() {
    return {
      form: {
        highRisk: "0",
        valueA: "0",
        valueB: "0",
        mianA: "0",
        mianB: "0",
        mianC: "0",
        mianD: "0",
        mianE: "0",
        mianF: "0",
        mianG: "0",
        lightAndMainA: "0",
        lightA: "0",
        lightB: "0",
        lightC: "0",
        lightD: "0",
        lightE: "0",
      },
      hasScore: false,
      disabled: false,
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = '';
      let riskMainScore = 0
      let riskLightScore = 0
      let lowMainScore = 0
      let lowLightScore = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            if (form[key] == "---") {
              flag = false;
            } else {
              form[key] = Number(form[key]);
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "--";
      } else {
        riskMainScore = form.mianA + form.mianB + form.mianG + form.mianC + form.mianD + form.mianF + form.lightAndMainA 
        riskLightScore = form.lightA + form.lightC +  form.lightD + form.lightE
        lowMainScore = form.mianA + form.mianB + form.mianG + form.mianC + form.mianD +  form.mianE
        lowLightScore = form.lightAndMainA + form.lightB + form.lightD + form.lightE
        if(form.highRisk) {
          if(form.valueA && (riskMainScore >=2 || (riskMainScore >=1 && riskLightScore>=2))) {
            result = '初次急性风湿热'
          }
          if((form.valueA &&form.valueB) &&(riskMainScore >=2 ||(riskMainScore >=1 && riskLightScore>=2) || (riskLightScore>=3))) {
            result = '复发急性风湿热'
          }
        } else {
          if(form.valueA && (riskMainScore >=2 || (riskMainScore >=1 && riskLightScore>=2))) {
            result = '初次急性风湿热'
          }
           if((form.valueA &&form.valueB) &&(riskMainScore >=2 ||(riskMainScore >=1 && riskLightScore>=2) || (riskLightScore>=3))) {
            result = '复发急性风湿热'
          }
        }
  
        self.hasScore = true;
        return result;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/RFAHAJONES.vue